import { render, staticRenderFns } from "./squareBottom.vue?vue&type=template&id=b6243d26&scoped=true&"
import script from "./squareBottom.vue?vue&type=script&lang=js&"
export * from "./squareBottom.vue?vue&type=script&lang=js&"
import style0 from "./squareBottom.vue?vue&type=style&index=0&id=b6243d26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6243d26",
  null
  
)

export default component.exports